import { Navigate, useLocation } from 'react-router-dom';

/** Preserves subpaths and query strings when replacing a legacy URL prefix. */
export function LegacyRedirect({
  from,
  to,
  defaultSearch
}: {
  from: string;
  to: string;
  defaultSearch?: Record<string, string>;
}) {
  const location = useLocation();
  const suffix = location.pathname.slice(from.length);
  const search = new URLSearchParams(location.search);
  for (const [key, value] of Object.entries(defaultSearch ?? {})) {
    if (!search.has(key)) search.set(key, value);
  }
  const query = search.size > 0 ? `?${search.toString()}` : '';
  return <Navigate to={`${to}${suffix}${query}${location.hash}`} replace />;
}
